import React from "react";
import PropTypes from "prop-types";

import { Icon } from "semantic-ui-react";

function ErrorMessagePassword({ errors }) {
  const errorTypeToMessage = {
    min: "8 characters",
    uppercase: "Uppercase letter",
    lowercase: "Lowercase letter",
    number: "Number",
    special: "Special character !@#$%^&*",
  };

  const getIcon = (val) => {
    return val in errors ? (
      <Icon name="close" color="red" />
    ) : (
      <Icon name="check" color="green" />
    );
  };
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        gridTemplateAreas: `'min uppercase lowercase' 'number special special'`,
      }}
      data-test="error-password-container"
    >
      {Object.keys(errorTypeToMessage).map((errorType) => {
        return (
          <span
            key={`error-password-${errorType}`}
            style={{
              gridArea: errorType,
              fontSize: "12px",
              color: "#1B1C1D",
            }}
          >
            {getIcon(errorType)}
            {errorTypeToMessage[errorType]}
          </span>
        );
      })}
    </div>
  );
}

ErrorMessagePassword.propTypes = {
  errors: PropTypes.object,
};

ErrorMessagePassword.defaultProps = {
  errors: {},
};

export default ErrorMessagePassword;
